<div class="flex flex-col h-full w-full bg-gray-100">

    <!-- Zone du PDF (50% de la hauteur) -->
    <div
        #scrollContainer
        (scroll)="onScroll()"
        class="h-full overflow-y-auto scroll-smooth overscroll-contain"
        style="-webkit-overflow-scrolling: touch;">

        <div #canvasContainer class="flex flex-col items-center">
            <!-- Les canvas seront injectés ici -->
        </div>
    </div>



</div>